import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Table from '../../components/table/table';
import { DataType, RowObject, Tbody } from '../../components/table/tableModels';
import * as Client from '../../data/apiClient/client';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { shipmentsActionCreators } from '../../data/shipment/shipmentAction';
import { ShipmentObject, ShipmentState } from '../../data/shipment/shipmentModels';

// tslint:disable-next-line:no-var-requires
const moment = require('moment');
// tslint:disable-next-line:no-var-requires
const shipmentsicon = require('../../resources/shipments.png');

type ShipmentProps = LocalShipmentState & ShipmentAction & RouteComponentProps<{ id: string }>;

interface LocalShipmentState {
    shipments: ShipmentState;
    header: HeaderState;
}

interface ShipmentAction {
    shipmentActions: typeof shipmentsActionCreators;
    headerActions: typeof headerActionCreators;
}

interface State {
    shipment: ShipmentObject | undefined;
    tHead: Array<RowObject>;
    shipmentDetailList: Array<Tbody>;
}

class Shipment extends React.Component<ShipmentProps, State> {
    constructor(props: ShipmentProps) {
        super(props);
        this.getTheShipment = this.getTheShipment.bind(this);
        this.state = {
            shipment: undefined,
            tHead: [
                new RowObject(DataType.string, 'Pack Slip', undefined, undefined, undefined),
                new RowObject(DataType.string, 'Pallet ID', undefined, undefined, undefined),
                new RowObject(DataType.string, 'Item Number', undefined, undefined, undefined),
                new RowObject(DataType.string, 'Item Description', undefined, undefined, undefined),
                // new RowObject(DataType.string, 'Ship City', undefined, undefined, undefined),
                new RowObject(DataType.number, 'Quantity', undefined, undefined, undefined)
            ],
            shipmentDetailList: []
        };
    }

    getTbody(shipment: ShipmentObject) {
        let ShipmentDetailList = new Array<Tbody>();

        ShipmentDetailList = shipment.details!.map((data) => {
            const rBody = new Array<RowObject>();

            rBody.push(new RowObject(DataType.string, data.packSlip ? data.packSlip : '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.palletID ? data.palletID : '', null, undefined, undefined));

            rBody.push(
                new RowObject(DataType.string, data.itemNumber ? data.itemNumber : '', null, undefined, undefined)
            );

            rBody.push(new RowObject(DataType.string, data.description ? data.description : '', null, undefined, undefined));

            // rBody.push(new RowObject(DataType.string, '', null, undefined, undefined));

            rBody.push(new RowObject(DataType.string, data.quantity ? data.quantity : 0, null, undefined, undefined));
            
            const row = new Tbody(
                rBody,
                undefined,
                undefined,
                undefined // data.description ? { lable: '', description: data.description } : undefined
            );
            
            return row;
            
        });
        this.setState({ shipmentDetailList: ShipmentDetailList });
    }

    componentWillMount() {
        this.getTheShipment(this.props.match.params.id);
    }

    componentDidUpdate(prevProps: ShipmentProps) {
        if (this.props.shipments.shipments !== prevProps.shipments.shipments) {
            this.getTheShipment(this.props.match.params.id);
        }
    }

    getTheShipment(shipmentId: string) {
        const shipmentClient = new Client.ShipmentsClient();
        shipmentClient.get(shipmentId).then((res) => {         
            this.setState({
                shipment: res
            }, () => {
                this.getTbody(res);
            });
        });
        /* 
        this.props.shipments.shipments.forEach((x) => {
            if (x.shipmentid === shipmentId) {
                this.setState({ shipment: x }, () => {
                    this.getTbody(x);
                });
            }
        });
        */
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Shipment'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={shipmentsicon} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.shipment !== undefined ? (
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Order Number:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.orderNumber}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Ship Date:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>
                                                {this.state.shipment.shipDate
                                                    ? moment(this.state.shipment.shipDate, 'M/D/YYYY').format(
                                                          'M/D/YYYY'
                                                      )
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">PO Number:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.pONumber}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Carrier:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.carrier}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Tracking Number:</div>
                                        </div>
                                        {this.state.shipment.trackLink ? (
                                            <div className="col-sm-6">
                                                <a href={this.state.shipment.trackLink} target={'_blank'}>
                                                    {this.state.shipment.trackNumber}
                                                </a>
                                            </div>
                                        ) : (
                                            <div className="col-sm-6">
                                                <div>{this.state.shipment.trackNumber}</div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="row hidden">
                                        <div className="col-sm-6">
                                            <div className="bold">Freight Charge:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.freightCharge}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Ship To:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.shipToName}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Ship To Address:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.shipToAddress}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Ship To City:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.shipToCity}</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="bold">Ship To State:</div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div>{this.state.shipment.shipToState}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="bold">Shipments details</div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Table
                                        // header={'Shipments details'}
                                        tHead={this.state.tHead}
                                        tBody={this.state.shipmentDetailList}
                                        listSize={this.state.shipmentDetailList.length}
                                        hover={true}
                                        cursor={true}
                                        hidePagination={true}
                                        americanDateFormat={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): LocalShipmentState {
    return {
        shipments: state.shipments,
        header: state.header
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): ShipmentAction {
    return {
        shipmentActions: bindActionCreators(shipmentsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(Shipment)
);



// WEBPACK FOOTER //
// ./src/containers/shipment/shipment.tsx